import Link from 'next/link';
 import Icon from'@/components/ui/AppIcon';

export default function Footer() {
  const companyLinks = [
    { id: 'footer_about', label: 'About Us', href: '/homepage#about' },
    { id: 'footer_careers', label: 'Careers', href: '/homepage#careers' },
    { id: 'footer_press', label: 'Press', href: '/homepage#press' },
  ]

  const productLinks = [
    { id: 'footer_pricing', label: 'Pricing', href: '/homepage#vehicles' },
    { id: 'footer_safety', label: 'Safety', href: '/homepage#safety' },
    { id: 'footer_cities', label: 'Cities', href: '/homepage#cities' },
  ]

  const supportLinks = [
    { id: 'footer_help', label: 'Help Center', href: '/homepage#help' },
    { id: 'footer_contact', label: 'Contact Us', href: '/homepage#contact' },
    { id: 'footer_faq', label: 'FAQ', href: '/booking#faq' },
  ]

  const legalLinks = [
    { id: 'footer_privacy', label: 'Privacy Policy', href: '/homepage#privacy' },
    { id: 'footer_terms', label: 'Terms of Service', href: '/homepage#terms' },
    { id: 'footer_cookies', label: 'Cookie Policy', href: '/homepage#cookies' },
  ]

  const socialLinks = [
    { id: 'social_twitter', icon: 'twitter', href: 'https://twitter.com/maxiride', label: 'Twitter' },
    { id: 'social_instagram', icon: 'instagram', href: 'https://instagram.com/maxiride', label: 'Instagram' },
    { id: 'social_linkedin', icon: 'linkedin', href: 'https://linkedin.com/company/maxiride', label: 'LinkedIn' },
  ]

  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="max-w-7xl mx-auto px-6 py-12">
        {/* Main Footer Content */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-12">
          {/* Company Links */}
          <div>
            <h3 className="text-sm font-display font-semibold mb-4 text-accent">
              Company
            </h3>
            <ul className="space-y-2">
              {companyLinks?.map((link) => (
                <li key={link?.id}>
                  <Link
                    href={link?.href}
                    className="text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Product Links */}
          <div>
            <h3 className="text-sm font-display font-semibold mb-4 text-accent">
              Product
            </h3>
            <ul className="space-y-2">
              {productLinks?.map((link) => (
                <li key={link?.id}>
                  <Link
                    href={link?.href}
                    className="text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support Links */}
          <div>
            <h3 className="text-sm font-display font-semibold mb-4 text-accent">
              Support
            </h3>
            <ul className="space-y-2">
              {supportLinks?.map((link) => (
                <li key={link?.id}>
                  <Link
                    href={link?.href}
                    className="text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal Links */}
          <div>
            <h3 className="text-sm font-display font-semibold mb-4 text-accent">
              Legal
            </h3>
            <ul className="space-y-2">
              {legalLinks?.map((link) => (
                <li key={link?.id}>
                  <Link
                    href={link?.href}
                    className="text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors"
                  >
                    {link?.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-primary-foreground/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          {/* Copyright */}
          <p className="text-sm text-primary-foreground/60">
            © 2026 ScootRide. All rights reserved.
          </p>

          {/* Social Links */}
          <div className="flex items-center gap-4">
            {socialLinks?.map((social) => (
              <a
                key={social?.id}
                href={social?.href}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-primary-foreground/10 hover:bg-accent flex items-center justify-center transition-all hover:scale-110"
                aria-label={social?.label}
              >
                <Icon
                  name={
                    social?.icon === 'twitter' ?'ChatBubbleLeftIcon'
                      : social?.icon === 'instagram' ?'CameraIcon' :'BriefcaseIcon'
                  }
                  size={18}
                  className="text-primary-foreground"
                />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}